import { createContext, useContext, useState, useEffect } from 'react';

const FontSizeContext = createContext();

const MIN_SCALE = 0.85;
const MAX_SCALE = 1.5;
const STEP = 0.05;

export function FontSizeProvider({ children }) {
  const [scale, setScale] = useState(() => {
    const saved = localStorage.getItem('dr-ambrish-fontscale');
    return saved ? parseFloat(saved) : 1;
  });

  useEffect(() => {
    document.documentElement.style.setProperty('--font-scale', scale);
    localStorage.setItem('dr-ambrish-fontscale', scale);
  }, [scale]);

  const increase = () => setScale((prev) => Math.min(prev + STEP, MAX_SCALE));
  const decrease = () => setScale((prev) => Math.max(prev - STEP, MIN_SCALE));
  const reset = () => setScale(1);

  return (
    <FontSizeContext.Provider value={{ scale, setScale, increase, decrease, reset, MIN_SCALE, MAX_SCALE }}>
      {children}
    </FontSizeContext.Provider>
  );
}

export function useFontSize() {
  const ctx = useContext(FontSizeContext);
  if (!ctx) throw new Error('useFontSize must be within FontSizeProvider');
  return ctx;
}
